import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

export class BaseDataSource implements DataSource<any[]> {
    private dataSubject = new BehaviorSubject<any[]>([]);

    private loadingSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this.loadingSubject.asObservable();

    constructor(private mainServie: any) {}

    loadData(
        courseId: number,
        filter: string,
        sortDirection: string,
        pageIndex: number,
        pageSize: number
    ) {
        this.loadingSubject.next(true);

        this.mainServie
            .fetchData(courseId, filter, sortDirection, pageIndex, pageSize)
            .pipe(
                catchError(() => of([])),
                finalize(() => this.loadingSubject.next(false))
            )
            .subscribe((data) => this.dataSubject.next(data));
    }

    connect(collectionViewer: CollectionViewer): Observable<any[]> {
        console.log('Connecting data source');
        return this.dataSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.dataSubject.complete();
        this.loadingSubject.complete();
    }
}
